module.exports = __webpack_public_path__ + "static/media/ico_arrow_down_white.9d503eb3.svg";